import React from "react";
import { BADGE_STYLES } from "./PortfolioRenderer";
import AutoVideo from "./AutoVideo";

// Horizontal cover header used by digital business cards.
// Supports image or video, with an adjustable vertical position to "center/crop".
export const CoverHeader = ({ portfolio }) => {
  const { profile = {}, cover = {} } = portfolio;
  const type = cover.type || "image";
  const url = cover.url;
  const pos = typeof cover.position === "number" ? cover.position : 50;
  const badgeStyle = BADGE_STYLES[profile.badgeStyle] || BADGE_STYLES.check;
  const BadgeIcon = badgeStyle.icon;

  return (
    <div className="w-full">
      <div className="relative overflow-hidden rounded-3xl border border-white/15 shadow-2xl">
        <div className="relative aspect-[16/9] w-full bg-gradient-to-br from-blue-600 to-indigo-700">
          {url ? (
            type === "video" ? (
              <AutoVideo
                src={url}
                className="absolute inset-0 h-full w-full object-cover"
                style={{ objectPosition: `center ${pos}%` }}
              />
            ) : (
              <img
                src={url}
                alt={profile.businessName}
                className="absolute inset-0 h-full w-full object-cover"
                style={{ objectPosition: `center ${pos}%` }}
              />
            )
          ) : (
            <div className="flex h-full w-full items-center justify-center font-display text-4xl font-bold text-white/90">
              {(profile.businessName || "U").charAt(0)}
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
        </div>
      </div>

      <div className="mt-4 flex flex-col items-center text-center">
        <div className="flex items-center gap-2">
          <h1 className="font-display text-2xl font-bold text-white">
            {profile.businessName}
          </h1>
          {profile.verified && (
            <span className={`flex h-6 w-6 items-center justify-center rounded-full ${badgeStyle.bg}`}>
              <BadgeIcon className="h-3.5 w-3.5 text-white" />
            </span>
          )}
        </div>
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/65">
          {profile.subtitle}
        </p>
      </div>
    </div>
  );
};

export default CoverHeader;
